import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, toast } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Chip, FormGroup, FormControlLabel, Switch, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { monthNames } from 'src/utils/date';
import AbosorbAdjustmentsConfirmation from './AbosorbAdjustmentsConfirmation';
import CorrectionsDetails from './CorrectionsDetails';
import SummaryTable from './summaryTable';
import useAllocationUtilityStyles from '../styles';
const CorrectionsTable = observer(_ref => {
  let allocationCycleId = _ref.allocationCycleId,
    fromHistory = _ref.fromHistory;
  const classes = useAllocationUtilityStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const correctionsDetails = store.corrections.correctionsDetails.get(allocationCycleId) || {};
  const correctionAllocationCycles = (correctionsDetails === null || correctionsDetails === void 0 ? void 0 : correctionsDetails.correctionAllocationCycles) || [];
  const correctionId = correctionsDetails.correctionId,
    correctionSummary = correctionsDetails.correctionSummary,
    isExcluded = correctionsDetails.isExcluded,
    setIsExcluded = correctionsDetails.setIsExcluded;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  const postExcludeCorrection = async () => {
    const resp = await store.allocations.postExcludeCorrectionAsync.run({
      correctionId
    });
    return resp;
  };
  const postIncludeCorrection = async () => {
    const resp = await store.allocations.postIncludeCorrectionAsync.run({
      correctionId
    });
    return resp;
  };
  const handleAbsorbSwitch = e => {
    e.stopPropagation();
    setIsOpen(true);
    setIsExcluded(!isExcluded);
  };
  const handleClose = () => {
    setIsOpen(false);
    setIsExcluded(!isExcluded);
  };
  const handleSubmit = async () => {
    Promise.all([isExcluded ? postExcludeCorrection() : postIncludeCorrection()]).then(() => {
      toast('success', {
        body: [t("corrections.".concat(isExcluded ? 'exclude' : 'include', "_success"))]
      });
    });
    setIsOpen(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.correctionsTable, " ").concat(isExcluded ? '' : classes.warning)
  }, isExcluded ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('corrections.billing_adjustments_notice_title')), /*#__PURE__*/React.createElement(Typography, {
    marginBottom: "18px",
    variant: "body1"
  }, t('corrections.billing_adjustments_notice'))), /*#__PURE__*/React.createElement(Accordion, {
    expanded: isExpanded
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-details",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-details",
    onClick: () => setIsExpanded(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('corrections.adjustment_charged_adjustments')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, correctionAllocationCycles.map(c => "".concat(monthNames[c.month - 1].slice(0, 3), " ").concat(c.year)).join(', '))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttons
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    checked: isExcluded,
    className: "".concat(fromHistory ? classes.disabledSwitch : ''),
    control: /*#__PURE__*/React.createElement(Switch, {
      checked: isExcluded
    }),
    onClick: handleAbsorbSwitch,
    label: /*#__PURE__*/React.createElement(Typography, {
      marginRight: "10px",
      variant: "h6"
    }, t('corrections.absorb_adjustments')),
    value: isExcluded
  })), /*#__PURE__*/React.createElement(AbosorbAdjustmentsConfirmation, {
    handleModalClose: handleClose,
    isExcluded: isExcluded,
    isOpen: isOpen,
    onSubmit: handleSubmit
  }), /*#__PURE__*/React.createElement(CorrectionsDetails, {
    allocationCycleId: allocationCycleId
  })))), /*#__PURE__*/React.createElement(AccordionDetails, null, isExcluded ? /*#__PURE__*/React.createElement("div", {
    className: classes.absorbTitle
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('corrections.billing_absorbed_adjustments_notice'),
    variant: "inactive"
  })) : null, /*#__PURE__*/React.createElement(SummaryTable, {
    isExcluded: isExcluded,
    residentSummaryEntries: correctionSummary === null || correctionSummary === void 0 ? void 0 : correctionSummary.residentSummaryEntries
  }))));
});
export default CorrectionsTable;